// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YlbUY","footer":"styles_footer__Fts11","passCodeTooltip":"styles_passCodeTooltip__1PY60"};